import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import ScrollHero from './components/ScrollHero';
import TeamSection from './components/TeamSection';
import Services from './components/Services';
import ImpactStory from './components/ImpactStory';
import Blog from './components/Blog';

import Contact from './components/Contact';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';
import Login from './components/Login';
import ClientResources from './components/ClientResources';
import AdminPanel from './components/AdminPanel';
import TermsConditions from './components/TermsConditions';
import ArticlePage from './components/ArticlePage';
import TreasuryStrategy from './components/TreasuryStrategy';
import CDFITreasury from './components/CDFITreasury';
import UnderwritingLending from './components/UnderwritingLending';
import NMTCConsulting from './components/NMTCConsulting';
import AIAutomation from './components/AIAutomation';
import AIDemo from './components/AIDemo';
import ResourcesPage from './components/ResourcesPage';
import NMTCModel from './components/NMTCModel';
import { AuthProvider } from './components/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import { scrollToSection } from './utils/scroll';
import { Analytics } from '@vercel/analytics/react';
import SEO from './components/SEO';

// ScrollToTop component to handle scrolling to top on route changes
const ScrollToTop = () => {
  const location = useLocation();
  const { state } = location;

  useEffect(() => {
    if (state?.scrollTo) {
      setTimeout(() => {
        scrollToSection(state.scrollTo);
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, state]);

  return null;
};

const RouteAwareSEO = () => {
  const location = useLocation();
  return <SEO pathname={location.pathname} />;
};

function App() {
  const baseUrl = document.getElementsByTagName('base')[0]?.getAttribute('href') || '/';

  return (
    <AuthProvider>
      <Router basename={baseUrl}>
        <div className="App">
          <a href="#main-content" className="skip-to-content">Skip to main content</a>
          <ScrollToTop />
          <Analytics />
          <RouteAwareSEO />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/article/:articleId" element={<ArticlePage />} />
            <Route path="/services/fund-structuring" element={<TreasuryStrategy />} />
            <Route path="/services/cdfi-treasury-strategy" element={<CDFITreasury />} />
            <Route path="/services/underwriting-lending" element={<UnderwritingLending />} />
            <Route path="/services/nmtc-consulting" element={<NMTCConsulting />} />
            <Route path="/services/ai-automation" element={<AIAutomation />} />
            <Route path="/ai-demo" element={<AIDemo />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/nmtc-model" element={<NMTCModel />} />
            <Route path="/client-resources" element={
              <PrivateRoute>
                <ClientResources />
              </PrivateRoute>
            } />
            <Route path="/" element={
              <>
                <Navbar />
                <main id="main-content">
                  <ScrollHero />
                  <TeamSection />
                  <Services />
                  <ImpactStory />
                  <Blog />
                  <Contact />
                </main>
                <Footer />
                <ChatBot />
              </>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
